<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @asignarroles="asignarroles($event)"
      @asignarpermisos="asignarpermisos($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>

    <!-- Modal roles -->
    <div
      class="modal fade"
      id="modal_roles"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-lg`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              ROLES DEL USUARIO "{{ `${item ? item.name : ""}` }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Rol</th>
                      <th class="text-center">Sistema</th>
                      <th class="text-center">Guard</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(r, idx) in roles" :key="idx">
                      <td class="text-center">{{ r.id }}</td>
                      <td>
                        {{ r.name }}
                        <div class="custom-tooltip">
                          <i class="fas fa-info text-primary"></i>
                          <span class="custom-tooltiptext">
                            {{ r.name }}
                            <ul>
                              <li v-for="menu in r.menus">{{menu.texto}}</li>
                            </ul>
                          </span>
                        </div>
                      </td>
                      <td>{{ r.sistema }}</td>
                      <td class="text-center">{{ r.guard_name }}</td>
                      <td class="text-center">
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="r.id"
                          v-model="r.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="guardar_roles"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal roles -->

    <!-- Modal permisos -->
    <div
      class="modal fade"
      id="modal_permisos"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-lg`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              PERMISOS DEL USUARIO "{{ `${item ? item.name : ""}` }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Permiso</th>
                      <!-- <th class="text-center">Sistema</th> -->
                      <th class="text-center">Guard</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, idx) in permisos" :key="idx">
                      <td class="text-center">{{ p.id }}</td>
                      <td>{{ p.name }}</td>
                      <!-- <td>{{p.sistema}}</td> -->
                      <td class="text-center">{{ p.guard_name }}</td>
                      <td class="text-center">
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="p.id"
                          v-model="p.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="guardar_permisos"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal permisos -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Swal from "sweetalert2";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "user",
        label: "Usuario",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "user",
      },
      {
        key: "name",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "name",
      },
      {
        key: "email",
        label: "Correo Electrónico",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "email",
      },
      {
        key: "firma_html",
        label: "Firma",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "firma_html",
      },
      {
        key: "habilitado_romana2",
        label: "Habilitado Romana",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "habilitado_romana_texto",
        opciones: [
          { id: "0", label: "No" },
          { id: "1", label: "Si" },
        ],
        valor_opcion: "id",
        label_opcion: "label",
      },
      {
        key: "cargo_id",
        label: "Cargo",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "cargo.nombre",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Roles",
        clase: "btn-primary",
        evento: "asignarroles",
        icono: "fa fa-users",
      },
      {
        label: "Permisos",
        clase: "btn-primary",
        evento: "asignarpermisos",
        icono: "fas fa-walking",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "user",
        valor: "",
        label: "Rut (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "name",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "email",
        valor: "",
        label: "Correo (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "select",
        key: "habilitado_romana2",
        valor: "",
        label: "Habilitado Romana",
        disabled: false,
        opciones: [
          { id: "0", label: "No" },
          { id: "1", label: "Si" },
        ],
        valor_opcion: "id",
        label_opcion: "label",
      },
      {
        cols: 4,
        tipo: "select",
        key: "cargo_id",
        valor: "",
        label: "Cargo",
        disabled: false,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 4,
        tipo: "texto",
        key: "password",
        valor: "",
        label: "Clave",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "file",
        key: "filename",
        valor: "",
        label: "Firma",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Usuario",
      ancho: "lg",
      ruta: "/usuarios",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Usuarios",
      titulo_boton: "Crear Usuario",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    item: null,
    roles: [],
    permisos: [],
    roles_ids: [],
    permisos_ids: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        const guardada = storage.columnas.find((c) => c.key == col.key);
        if (guardada) {
          col.busqueda = guardada.val;
        }
      });
    }
    this.cargar_roles();
    this.cargar_cargos();
  },
  methods: {
    async cargar_cargos() {
      await this.axios
        .get(`${this.api}/cargos?limit=99999`, this.cabeceras_json)
        .then((res) => {
          const opciones = res.data.data.data;
          this.inputs.find((i) => i.key === "cargo_id").opciones = opciones;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_roles() {
      await this.axios
        .get(`${this.api}/roles?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.roles = res.data.data.data;
          //console.log('roles',this.roles);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_permisos();
    },

    async cargar_permisos() {
      await this.axios
        .get(`${this.api}/permissions?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.permisos = res.data.data.data;
          //console.log('permisos',this.permisos);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/usuarios${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/usuarios${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/usuarios`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/usuarios/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },

    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    async guardar_roles() {
      let body = {
        roles_names: this.roles
          .filter((r) => r.check == true)
          .map((r) => r.name),
      };
      await this.axios
        .post(
          `${this.api}/usuarios/${this.item.id}/guardar_roles`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            confirmButtonColor: "#2dce89"
          });
          //console.log('respuesta',res.data);
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardar_permisos() {
      let body = {
        permissions_names: this.permisos
          .filter((p) => p.check == true)
          .map((p) => p.name),
      };
      await this.axios
        .post(
          `${this.api}/usuarios/${this.item.id}/guardar_permisos`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            confirmButtonColor: "#2dce89"
          });
          //console.log('respuesta',res.data);
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    asignarroles(event) {
      this.resetear_roles();
      this.item = event.item;
      this.roles_ids = this.item.roles_ids;
      this.setear_roles();
      $("#modal_roles").modal({ show: true });
    },

    resetear_roles() {
      this.roles.forEach((r) => {
        r.check = false;
      });
    },

    setear_roles() {
      this.roles.forEach((r) => {
        let check = this.roles_ids.findIndex((id) => r.id == id);
        if (check != -1) {
          r.check = true;
        }
      });
    },

    asignarpermisos(event) {
      this.resetear_permisos();
      this.item = event.item;
      this.permisos_ids = this.item.permisos_ids;
      this.setear_permisos();
      $("#modal_permisos").modal({ show: true });
    },

    resetear_permisos() {
      this.permisos.forEach((p) => {
        p.check = false;
      });
    },

    setear_permisos() {
      this.permisos.forEach((p) => {
        let check = this.permisos_ids.findIndex((id) => p.id == id);
        if (check != -1) {
          p.check = true;
        }
      });
    },

    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>

<style scoped>

/* Tooltip container */
.custom-tooltip {
  float: right;
  position: relative;
  display: inline;
  min-width: 1.1rem;
  text-align: center;
  border-radius: 100%;
  border: rgba(82, 95, 127, 0.4) solid 1px;
}

/* Tooltip text */
.custom-tooltip .custom-tooltiptext {
  visibility: hidden;
  width: max-content;
  background-color: rgb(41, 50, 65);
  color: #fff;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 3;
  max-height: 15rem;
  overflow: auto;
}

/* Show the tooltip text when you mouse over the tooltip container */
.custom-tooltip:hover .custom-tooltiptext {
  visibility: visible;
}

.custom-tooltip .custom-tooltiptext {
  top: -5px;
  left: 105%;
  text-align: left;
  padding: 6px 6px 0;
}

.custom-tooltip .custom-tooltiptext ul {
  padding: 6px;
  margin: 0;
  list-style-position: inside;
}

</style>